// Utility for setting and getting localStorage items with expiration
const TWO_HOURS_MS = 2 * 60 * 60 * 1000;

export function setExpiringItem(key, value, ttl = TWO_HOURS_MS) {
  const expiresAt = Date.now() + ttl;
  const item = { value, expiresAt };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getExpiringItem(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;
  try {
    const item = JSON.parse(itemStr);
    if (item.expiresAt && item.expiresAt > Date.now()) {
      return item.value;
    } else {
      localStorage.removeItem(key);
      return null;
    }
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function removeExpiringItem(key) {
  localStorage.removeItem(key);
}